import { CLIENT_GET_FAILURE, CLIENT_GET_REQUEST, CLIENT_GET_SUCCESS } from 'redux-coreapi'

function handleClientGetFailure (state, { error }) {
  return {
    ...state,
    error,
    loading: false,
  }
}

function handleClientGetRequest (state) {
  return {
    ...state,
    loading: true,
  }
}

function handleClientGetSuccess (state, { document: schema }) {
  return {
    ...state,
    schema,
    error: undefined,
    loading: false,
  }
}

const handlerMap = {
  [CLIENT_GET_FAILURE]: handleClientGetFailure,
  [CLIENT_GET_REQUEST]: handleClientGetRequest,
  [CLIENT_GET_SUCCESS]: handleClientGetSuccess,
}

export function getSchema (state) {
  return state.schema.schema
}

export function cleanValues (values, state, object_type, action, apiKey = 'rest') {
  let schema = getSchema(state)
  let obj_description
  // TODO handle apiKey better
  if (apiKey) {
    obj_description = schema.content[apiKey][object_type][action]
  } else {
    obj_description = schema.content[object_type][action]
  }

  let field_names = obj_description.fields.map(field => field.name)
  let to_delete = []
  for (let value in values) {
    if (field_names.indexOf(value) === -1) {
      to_delete.push(value)
    }
  }
  for (let td of to_delete) {
    delete values[td]
  }
  return values
}

export default function document (state = {}, action) {
  if (action.type in handlerMap) {
    return handlerMap[action.type](state, action.payload)
  }
  return state
}

